import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import './CustomerLogin.scss';
import { RootState } from 'src/configs/store';

function CustomerLogin() {
  const [userDetails, setUserDetails] = useState({ cardNumber: '', password: '' });
  const [error, setError] = useState('');
  const [focus, setFocus]= useState('card');

  const { t } = useTranslation();
  const customerCard = useSelector((state: RootState) => state.auth.customerCard);
  const dispatch = useDispatch();

  const cardRef = useRef(null);
  const passwordRef = useRef(null);
  const secondScreenRef = useRef(null);

  useEffect(() => {
    if (customerCard){
      setUserDetails({ ...userDetails, cardNumber: customerCard });
      dispatch.auth.addNumberCustomer(null);
      passwordRef.current.focus();
      setFocus('password');
    }
  }, []);

  const arrowFunction = useCallback((e) => {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown'){
      e.preventDefault();
      if (focus === 'password'){
        cardRef.current.focus();
        setFocus('card');
      } else {
        passwordRef.current.focus();
        setFocus('password');
      }
    }
  }, [focus]);

  useEffect(() => {
    secondScreenRef.current.addEventListener('keydown', arrowFunction);
    return () => {
      secondScreenRef.current.removeEventListener('keydown', arrowFunction);
    };
  }, [secondScreenRef, focus]);

  const handleChange = (e) => {
    if (error){
      setError('');
    }

    if (e.target.name === 'password'){
      setUserDetails({ ...userDetails, password: e.target.value });
    } else {
      setUserDetails({ ...userDetails, cardNumber: e.target.value });
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const loginError = await dispatch.auth.userByPin({ 'cardNumber': userDetails.cardNumber, password: userDetails.password });
    if (loginError){
      setError(loginError);
    }
  };

  return (
    <div className="login-second-screen" ref={ secondScreenRef }>
      <form className="login-second-screen__form" onSubmit={ handleFormSubmit }>
        <div className="login-second-screen__input-container">
          <span className="login-second-screen__label">{ t('secondScreen.cardNumber') }</span>
          <input
            type="text"
            onChange={ handleChange }
            name="cardNumber"
            autoFocus
            ref={ cardRef }
            value={ userDetails.cardNumber }
            className="login-second-screen__input"
            placeholder={ t('secondScreen.cardNumber') }
          />
        </div>
        <div className="login-second-screen__input-container">
          <span className="login-second-screen__label">{ t('secondScreen.clientPin') }</span>
          <input
            onChange={ handleChange }
            name="password"
            value={ userDetails.password }
            type="password"
            ref={ passwordRef }
            className="login-second-screen__input"
            placeholder={ t('secondScreen.clientPin') }
          />
        </div>
        <button className="login-second-screen__submit-button" type="submit">{ t('secondScreen.login') }</button>
        {
          error &&
          <div className="login-second-screen__error">
            { error }
          </div>
        }
      </form>
    </div>
  );
}

export default CustomerLogin;
